import React from 'react';
import RoleplayModalBody from './RoleplayModalBody';
import RoleplayModalBodyDetails from './RoleplayModalBodyDetails';
import styles from './AssignRoleplay.module.scss';

const AssignRoleplayModalBody = ({
  isLoadingAttitudes,
  isLoadingCoach,
  isInteractive,
  managerOption,
  isRep,
  itHasNoScenarios,
}) => {
  return isRep && managerOption && !isInteractive && itHasNoScenarios ? (
    <div className={styles.leftContent}>
      <RoleplayModalBody />
      <RoleplayModalBodyDetails
        isLoadingAttitudes={isLoadingAttitudes}
        isLoadingCoach={isLoadingCoach}
        isInteractive={isInteractive}
        managerOption={managerOption}
      />
    </div>
  ) : (
    <>
      <div className={styles.leftContent}>
        <RoleplayModalBody />
      </div>

      <div className={styles.rightContent}>
        <RoleplayModalBodyDetails
          isLoadingAttitudes={isLoadingAttitudes}
          isLoadingCoach={isLoadingCoach}
          isInteractive={isInteractive}
          managerOption={managerOption}
        />
      </div>
    </>
  );
};

export default AssignRoleplayModalBody;
